// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
#file-section {
  margin-top: 50px;
  margin-left: 50px;
}

#error-main-container {
  width: 78%;
  margin-left: 11%;
}

.error-message {
  margin-left: 0px;
}

.download {
  display: inline-block;
}

p {
  margin-left: 5px;
}

.main-div {
  margin-left: 13%;
  margin-right: 13%;
  margin-top: 20px;
  margin-bottom: 20px;
}

@media (max-width: 1024px) {
  .main-div {
    margin-left: 3%;
    margin-right: 3%;
  }
}

.fan-no {
  width: 2%;
  width: 25px;
  height: 25px;
}

.formSpan {
  margin-left: 37px;
}

.info-box {
  width: 100%;
  background-color: #f2f2f2;
  padding: 25px 20px 0px 20px;
  margin-bottom: 25px;
}

.heading1 {
  font-size: 33px;
  font-weight: 500;
  margin-bottom: 0px;
  margin-left: -5px;
}
@media (max-width: 1024px) {
  .heading1 {
    font-size: 27px;
  }
}

h3 {
  margin-bottom: 10px;
}

ul {
  padding-left: 20px;
}
ul li {
  list-style-type: disc;
}
@media (max-width: 1024px) {
  ul {
    font-size: 5px !important;
  }
}

table {
  table-layout: fixed;
  margin-top: -15px;
}

tr, thead, th, td {
  border-bottom: none;
  font-size: 16px;
}

.planDesc {
  margin-top: -15px;
}

.heading {
  font-size: 33px;
  font-weight: 500;
  margin-bottom: 0px;
}
@media (max-width: 1024px) {
  .heading {
    font-size: 27px;
  }
}

.sub-heading {
  font-size: 16px;
  opacity: 1;
  margin-left: 6px;
}

.enrollment-type-heading {
  font-size: 32px;
  margin-left: 4px;
}
@media (max-width: 1024px) {
  .enrollment-type-heading {
    font-size: 27px;
    line-height: 25px;
  }
}

.enrollment-type-section {
  margin-top: 35px;
}

.enrollment-type-description {
  font-size: 15px;
  opacity: 1;
  margin-left: 6px;
}

.second {
  margin-left: 7px;
  margin-top: 15px;
}

@media (max-width: 352px) {
  .second {
    margin-left: 7px;
    margin-top: 7px;
  }
}
.third {
  margin-left: 7px;
  margin-top: 15px;
}

@media (max-width: 352px) {
  .third {
    margin-left: 7px;
    margin-top: 7px;
  }
}
.fourth {
  margin-left: 7px;
  margin-top: 15px;
}

@media (max-width: 352px) {
  .fourth {
    margin-left: 7px;
    margin-top: 7px;
  }
}
.first {
  margin-left: 7px;
}

.option-name {
  font-size: 16px;
}

.option-subname {
  font-size: 14px;
}

#off1, #off2, #off3, #off4 {
  width: 25px;
  height: 25px;
}
@media (max-width: 1024px) {
  #off1, #off2, #off3, #off4 {
    font-size: 5px !important;
  }
}

.billing-account-heading {
  font-size: 32px;
  margin-left: 4px;
}
@media (max-width: 1024px) {
  .billing-account-heading {
    font-size: 27px;
  }
}

.upload-heading {
  font-size: 32px;
}
@media (max-width: 1024px) {
  .upload-heading {
    font-size: 27px;
  }
}

.notifications-heading {
  font-size: 32px;
}
@media (max-width: 1024px) {
  .notifications-heading {
    font-size: 27px;
  }
}

.billing-account-section {
  margin-top: 10px;
}

.billing-account-field {
  margin-left: 6px;
  width: 50%;
  margin-top: 5px;
}
@media (max-width: 1024px) {
  .billing-account-field {
    width: 90%;
  }
}

.billing-account-label {
  margin-left: 20px;
}

.contact-section {
  margin-top: 10px;
}

.contact-heading {
  font-size: 32px;
}
@media (max-width: 1024px) {
  .contact-heading {
    font-size: 27px;
  }
}

.phone-number {
  margin-bottom: 8px;
}

.email {
  margin-bottom: 8px;
}

.span-bold {
  font-weight: 600;
}

.contact-name-label {
  margin-left: 22px;
}

.contact-name-field {
  margin-left: 7px;
  width: 50%;
  margin-top: 5px;
}
@media (max-width: 1024px) {
  .contact-name-field {
    width: 90%;
  }
}

.contact-number-section {
  margin-top: -10px;
}

.contact-number-label {
  margin-left: 22px;
}

.dropdown {
  margin-top: 5px;
  width: 50.5%;
}
@media (max-width: 1024px) {
  .dropdown {
    width: 90%;
  }
}

.zip-code-section {
  margin-top: -10px;
}

.contact-number-field {
  margin-left: 7px;
  width: 50%;
  margin-top: 5px;
}
@media (max-width: 1024px) {
  .contact-number-field {
    width: 90%;
  }
}

.zip-code-label {
  margin-left: 24px;
}

.time-section {
  margin-top: -10px;
}

.time-period-label {
  margin-left: 22px;
}

.time-period-field {
  margin-left: 6px;
  width: 50%;
  margin-top: 5px;
}
@media (max-width: 1024px) {
  .time-period-field {
    width: 90%;
  }
}

#time-period {
  margin-top: 15px;
  width: 100%;
}

.upload-section {
  width: 100%;
  margin-top: 15px;
}

.upload-label {
  margin-left: 7px;
  width: 90%;
  margin-bottom: 2px;
}

#file-upload-section {
  margin-left: 8px;
}

.file-details {
  display: inline-block;
}

#selectFile {
  width: 75%;
  border-radius: 6px;
  background-color: transparent;
  color: #1483D9;
  border: 1px solid #D0D1D2;
}

#file-upload-section {
  width: 50%;
}

.notifications-label {
  width: 100%;
}

a:hover {
  text-decoration: none;
}

.notification-labels {
  margin-bottom: 20px;
}

.step-indicator {
  width: 80%;
  margin-left: 10%;
}

#notification-email-label {
  margin-bottom: 15px;
  margin-left: 5px;
}

#notification-text-label {
  margin-left: 5px;
}

.acknowledgement-section {
  width: 100%;
  background-color: #f2f2f2;
  display: flexbox;
}

.acknowledgement-heading {
  margin-bottom: 5px;
  font-size: 16px;
  padding: 15px 15px 15px 15px;
  color: #000000;
  opacity: 1;
  font-weight: 600;
}

.acknowledgement-subheading {
  font-size: 16px;
  padding: 0px 15px 15px 15px;
  color: #000000;
  opacity: 1;
}

.continue-section {
  width: 100%;
  height: 50px;
  margin-bottom: 40px;
}

#cancel-option {
  float: right;
  margin-right: 20px;
  font-size: 18px;
  margin-top: 12px;
}

#continue-option {
  float: right;
}

.time-slot-section {
  margin-bottom: 30px;
  margin-left: -10px;
}

.notifications-section {
  margin-top: 15px;
}

.contact-name-error-field {
  margin-left: 5px;
  margin-top: 20px;
}

.ban-error-field, .contact-number-error-field, .time-slot-error-field {
  margin-left: 5px;
  margin-top: 20px;
}

:host ::ng-deep .text-danger {
  margin-top: -10px;
  margin-left: 15px;
  margin-bottom: 20px;
}

.tooltipActive + .helper-text {
  display: block;
  width: 1200%;
  bottom: 100%;
  margin-left: -43px;
}
@media (max-width: 1024px) {
  .tooltipActive + .helper-text {
    width: 600%;
  }
}

.inline-labels {
  display: inline-block;
}

.offers {
  display: flex;
  flex-direction: row;
}
.offers .offer1 {
  width: 375px;
  height: 125px;
  border: 1px solid black;
  margin: 15px 25px 15px 25px;
  border-radius: 40px;
  padding: 10px;
}
.offers .offer1 .offer-rates {
  margin-bottom: 0px;
}
.offers .offer1 .offer-headings {
  margin-bottom: 0px;
}
.offers .offer2 {
  width: 375px;
  height: 125px;
  border: 1px solid black;
  margin: 15px 25px 15px 25px;
  border-radius: 40px;
  padding: 10px;
}
.offers .offer2 .offer-rates {
  margin-bottom: 0px;
}
.offers .offer2 .offer-headings {
  margin-bottom: 0px;
}

.offers-1 {
  display: flex;
  flex-direction: row;
}
.offers-1 .offer1 {
  width: 375px;
  height: 125px;
  border: 1px solid black;
  margin: 15px 25px 25px 25px;
  border-radius: 40px;
  padding: 10px;
}
.offers-1 .offer1 .offer-rates {
  margin-bottom: 0px;
}
.offers-1 .offer1 .offer-headings {
  margin-bottom: 0px;
}
.offers-1 .offer2 {
  width: 375px;
  height: 125px;
  border: 1px solid black;
  margin: 15px 25px 25px 25px;
  border-radius: 40px;
  padding: 10px;
}
.offers-1 .offer2 .offer-rates {
  margin-bottom: 0px;
}
.offers-1 .offer2 .offer-headings {
  margin-bottom: 0px;
}

.firstnetErrorMessageLink {
  color: #0000EE;
  text-decoration: none;
  outline: none;
}

.flex-section {
  display: flex;
}

:host ::ng-deep .tooltip-input {
  margin-top: 0%;
  padding-left: 5%;
}

:host ::ng-deep i.tooltip-icon {
  top: 16px;
}

:host ::ng-deep .helper-text {
  margin-bottom: -9px;
}

.offer1-tooltip {
  top: 2px !important;
}

.offer1-helper-text {
  margin-bottom: 4px !important;
}

@media (max-width: 1024px) {
  .tooltip-position {
    padding-left: 20px;
  }
}
.sub-heading1 {
  font-size: 25px;
  margin-left: 0px !important;
}

@media (max-width: 1024px) {
  .sub-heading1 {
    margin-left: 45px !important;
  }
  .secondHeading {
    margin-top: -40px;
  }
  .radio-btn {
    margin-top: 20px;
  }
}
.radio-btn {
  width: 20px;
  margin-bottom: 7px;
  margin-left: 10px;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/signup-fiveg/enrollment-options/enrollment-options.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAjJA;EACI,gBAAA;EACA,iBAAA;AAmJJ;;AAhJA;EACI,UAAA;EACA,gBAAA;AAmJJ;;AAjJA;EACI,gBAAA;AAoJJ;;AAjJA;EACI,qBAAA;AAoJJ;;AAjJA;EACI,gBAAA;AAoJJ;;AAjJA;EACI,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AAoJJ;;AA/II;EADJ;IAEO,eAAA;IACA,gBAAA;EAmJL;AACF;;AAhJA;EACI,SAAA;EACA,WAAA;EACA,YAAA;AAmJJ;;AAjJA;EACI,iBAAA;AAoJJ;;AAjJA;EACI,WAAA;EACA,yBAAA;EACA,2BAAA;EACA,mBAAA;AAoJJ;;AAjJA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AAoJJ;AAnJI;EALJ;IAMQ,eAAA;EAsJN;AACF;;AAnJA;EACI,mBAAA;AAsJJ;;AAnJA;EACI,kBAAA;AAsJJ;AArJG;EACG,qBAAA;AAuJN;AFtMI;EE4CJ;IAOQ,yBAAA;EAuJN;AACF;;AApJA;EACI,mBAAA;EACA,iBAAA;AAuJJ;;AApJA;EACI,mBAAA;EACA,eAAA;AAuJJ;;AApJA;EACI,iBAAA;AAuJJ;;AApJA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;AAuJJ;AAtJI;EAJJ;IAKQ,eAAA;EAyJN;AACF;;AAvJA;EACI,eAAA;EACA,UAAA;EACA,gBAAA;AA0JJ;;AAxJA;EACI,eAAA;EACA,gBAAA;AA2JJ;AA1JI;EAHJ;IAIQ,eAAA;IACA,iBAAA;EA6JN;AACF;;AA3JA;EACI,gBAAA;AA8JJ;;AA5JA;EACI,eAAA;EACA,UAAA;EACA,gBAAA;AA+JJ;;AA7JA;EACI,gBAAA;EACA,gBAAA;AAgKJ;;AA9JA;EACI;IACI,gBAAA;IACA,eAAA;EAiKN;AACF;AA/JA;EACI,gBAAA;EACA,gBAAA;AAiKJ;;AA/JA;EACI;IACI,gBAAA;IACA,eAAA;EAkKN;AACF;AAhKA;EACI,gBAAA;EACA,gBAAA;AAkKJ;;AAhKA;EACI;IACI,gBAAA;IACA,eAAA;EAmKN;AACF;AAjKA;EACI,gBAAA;AAmKJ;;AAjKA;EACI,eAAA;AAoKJ;;AAlKA;EACI,eAAA;AAqKJ;;AAnKA;EACI,WAAA;EACA,YAAA;AAsKJ;AFjTI;EEyIJ;IAIQ,yBAAA;EAwKN;AACF;;AAtKA;EACI,eAAA;EACA,gBAAA;AAyKJ;AAxKI;EAHJ;IAIQ,eAAA;EA2KN;AACF;;AAzKA;EACI,eAAA;AA4KJ;AA3KI;EAFJ;IAGQ,eAAA;EA8KN;AACF;;AA5KA;EACI,eAAA;AA+KJ;AA9KI;EAFJ;IAGQ,eAAA;EAiLN;AACF;;AA/KA;EACI,gBAAA;AAkLJ;;AAhLA;EACI,gBAAA;EACA,UAAA;EACA,eAAA;AAmLJ;AAlLI;EAJJ;IAKQ,UAAA;EAqLN;AACF;;AAnLA;EACI,iBAAA;AAsLJ;;AApLA;EACI,gBAAA;AAuLJ;;AArLA;EACI,eAAA;AAwLJ;AAvLI;EAFJ;IAGQ,eAAA;EA0LN;AACF;;AAxLA;EACI,kBAAA;AA2LJ;;AAzLA;EACI,kBAAA;AA4LJ;;AA1LA;EACI,gBAAA;AA6LJ;;AA3LA;EACI,iBAAA;AA8LJ;;AA5LA;EACI,gBAAA;EACA,UAAA;EACA,eAAA;AA+LJ;AA9LI;EAJJ;IAKQ,UAAA;EAiMN;AACF;;AA/LA;EACI,iBAAA;AAkMJ;;AAhMA;EACI,iBAAA;AAmMJ;;AAjMA;EACI,eAAA;EACA,YAAA;AAoMJ;AAnMI;EAHJ;IAIQ,UAAA;EAsMN;AACF;;AApMA;EACI,iBAAA;AAuMJ;;AArMA;EACI,gBAAA;EACA,UAAA;EACA,eAAA;AAwMJ;AAvMI;EAJJ;IAKQ,UAAA;EA0MN;AACF;;AAxMA;EACI,iBAAA;AA2MJ;;AAzMA;EACI,iBAAA;AA4MJ;;AA1MA;EACI,iBAAA;AA6MJ;;AA3MA;EACI,gBAAA;EACA,UAAA;EACA,eAAA;AA8MJ;AA7MI;EAJJ;IAKQ,UAAA;EAgNN;AACF;;AA9MA;EACI,gBAAA;EACA,WAAA;AAiNJ;;AA/MA;EACE,WAAA;EACA,gBAAA;AAkNF;;AAhNA;EACI,gBAAA;EACA,UAAA;EACA,kBAAA;AAmNJ;;AA/MA;EACI,gBAAA;AAkNJ;;AAhNA;EACI,qBAAA;AAmNJ;;AAjNA;EACI,UAAA;EACA,kBAAA;EACA,6BAAA;EACA,cAAA;EACA,yBAAA;AAoNJ;;AAlNA;EACI,UAAA;AAqNJ;;AAnNA;EACI,WAAA;AAsNJ;;AApNA;EACI,qBAAA;AAuNJ;;AArNA;EACI,mBAAA;AAwNJ;;AAtNA;EACI,UAAA;EACA,gBAAA;AAyNJ;;AAvNA;EACI,mBAAA;EACA,gBAAA;AA0NJ;;AAxNA;EACI,gBAAA;AA2NJ;;AAzNA;EACI,WAAA;EACA,yBAAA;EACA,gBAAA;AA4NJ;;AA1NA;EACI,kBAAA;EACA,eAAA;EACA,4BAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AA6NJ;;AA3NA;EACI,eAAA;EACA,2BAAA;EACA,cAAA;EACA,UAAA;AA8NJ;;AA3NA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AA8NJ;;AA5NA;EACI,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AA+NJ;;AA7NA;EACI,YAAA;AAgOJ;;AA9NA;EACI,mBAAA;EACA,kBAAA;AAiOJ;;AA/NA;EACI,gBAAA;AAkOJ;;AAhOA;EACI,gBAAA;EACA,gBAAA;AAmOJ;;AAjOA;EACI,gBAAA;EACA,gBAAA;AAoOJ;;AAlOA;EACI,iBAAA;EACA,iBAAA;EACA,mBAAA;AAqOJ;;AAvNE;EACE,cAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AA0NJ;AF1kBI;EE4WF;IAMM,WAAA;EA4NN;AACF;;AAzNE;EACI,qBAAA;AA4NN;;AAzNE;EACI,aAAA;EACA,mBAAA;AA4NN;AA3NM;EACI,YAAA;EACA,aAAA;EACA,uBAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;AA6NV;AA5NU;EACI,kBAAA;AA8Nd;AA5NU;EACI,kBAAA;AA8Nd;AA3NM;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;AA6NR;AA5NQ;EACI,kBAAA;AA8NZ;AA5NQ;EACI,kBAAA;AA8NZ;;AAzNE;EACE,aAAA;EACA,mBAAA;AA4NJ;AA3NI;EACI,YAAA;EACA,aAAA;EACA,uBAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;AA6NR;AA5NQ;EACI,kBAAA;AA8NZ;AA5NQ;EACI,kBAAA;AA8NZ;AA3NI;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;AA6NN;AA5NM;EACE,kBAAA;AA8NR;AA5NI;EACI,kBAAA;AA8NR;;AAzNA;EACI,cAAA;EACA,qBAAA;EACA,aAAA;AA4NJ;;AAzNA;EACI,aAAA;AA4NJ;;AAzNA;EACI,cAAA;EACA,gBAAA;AA4NJ;;AAzNA;EACI,SAAA;AA4NJ;;AAzNA;EACI,mBAAA;AA4NJ;;AAzNA;EACI,mBAAA;AA4NJ;;AAzNA;EACI,6BAAA;AA4NJ;;AFprBI;EE4dJ;IACI,kBAAA;EA4NF;AACF;AAzNA;EACI,eAAA;EACA,2BAAA;AA2NJ;;AF9rBI;EEueA;IACA,4BAAA;EA2NF;EAzNE;IACI,iBAAA;EA2NN;EAzNE;IACI,gBAAA;EA2NN;AACF;AAxNA;EACI,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AA0NJ","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n#file-section {\n    margin-top: 50px;\n    margin-left: 50px;\n}\n\n#error-main-container {\n    width: 78%;\n    margin-left: 11%;\n}\n.error-message {\n    margin-left: 0px;\n}\n\n.download {\n    display: inline-block;\n}\n\np {\n    margin-left: 5px;\n}\n\n.main-div {\n    margin-left: 13%;\n    margin-right: 13%;\n    margin-top: 20px;\n    margin-bottom: 20px;\n    // height: 2000px;\n}\n\n.main-div {\n    @media (max-width: 1024px) {\n       margin-left: 3%;\n       margin-right: 3%;\n    }\n}\n\n.fan-no {\n    width: 2%;\n    width: 25px;\n    height: 25px;\n}\n.formSpan {\n    margin-left: 37px;\n}\n\n.info-box {\n    width: 100%;\n    background-color: #f2f2f2;\n    padding: 25px 20px 0px 20px;\n    margin-bottom: 25px;\n}\n\n.heading1 {\n    font-size: 33px;\n    font-weight: 500;\n    margin-bottom: 0px;\n    margin-left: -5px;\n    @media(max-width: 1024px) {\n        font-size: 27px;\n    }\n}\n\nh3 {\n    margin-bottom: 10px;\n}\n\nul{\n    padding-left: 20px;\n   li{\n      list-style-type : disc;\n      //padding-bottom: 20px;\n    } \n    @include respond-to(small) {\n        font-size:5px !important\n        }\n}\n\ntable {\n    table-layout: fixed;\n    margin-top: -15px;\n}\n\ntr, thead, th, td {\n    border-bottom: none;\n    font-size: 16px;\n}\n\n.planDesc {\n    margin-top: -15px;\n}\n\n.heading {\n    font-size: 33px;\n    font-weight: 500;\n    margin-bottom: 0px;\n    @media(max-width: 1024px) {\n        font-size: 27px;\n    }\n}\n.sub-heading {\n    font-size: 16px;\n    opacity: 1;\n    margin-left: 6px;\n}\n.enrollment-type-heading {\n    font-size: 32px;\n    margin-left: 4px;\n    @media(max-width: 1024px) {\n        font-size: 27px;\n        line-height: 25px;\n    }\n}\n.enrollment-type-section {\n    margin-top: 35px;\n}\n.enrollment-type-description {\n    font-size: 15px;\n    opacity: 1;\n    margin-left: 6px;\n}\n.second {\n    margin-left: 7px;\n    margin-top: 15px;\n}\n@media(max-width: 352px) {\n    .second {\n        margin-left: 7px;\n        margin-top: 7px;\n    }\n}\n.third {\n    margin-left: 7px;\n    margin-top: 15px;\n}\n@media(max-width: 352px) {\n    .third {\n        margin-left: 7px;\n        margin-top: 7px;\n    }\n}\n.fourth {\n    margin-left: 7px;\n    margin-top: 15px;\n}\n@media(max-width: 352px) {\n    .fourth {\n        margin-left: 7px;\n        margin-top: 7px;\n    }\n}\n.first {\n    margin-left: 7px;\n}\n.option-name {\n    font-size: 16px;\n}\n.option-subname {\n    font-size: 14px;\n}\n#off1, #off2, #off3, #off4 {\n    width: 25px;\n    height: 25px;\n    @include respond-to(small) {\n        font-size:5px !important\n        }\n}\n.billing-account-heading {\n    font-size: 32px;\n    margin-left: 4px;\n    @media(max-width: 1024px) {\n        font-size: 27px;\n    }\n}\n.upload-heading{\n    font-size: 32px;\n    @media(max-width: 1024px) {\n        font-size: 27px;\n    }\n}\n.notifications-heading {\n    font-size: 32px;\n    @media(max-width: 1024px) {\n        font-size: 27px;\n    }\n}\n.billing-account-section {\n    margin-top: 10px;\n}\n.billing-account-field {\n    margin-left: 6px;\n    width: 50%;\n    margin-top: 5px;\n    @media(max-width: 1024px) {\n        width: 90%;\n    }\n}\n.billing-account-label {\n    margin-left: 20px;\n}\n.contact-section {\n    margin-top: 10px;\n}\n.contact-heading {\n    font-size: 32px;\n    @media(max-width: 1024px) {\n        font-size: 27px;\n    }\n}\n.phone-number {\n    margin-bottom: 8px;\n}\n.email {\n    margin-bottom: 8px;\n}\n.span-bold {\n    font-weight: 600;\n}\n.contact-name-label {\n    margin-left: 22px;\n}\n.contact-name-field {\n    margin-left: 7px;\n    width: 50%;\n    margin-top: 5px;\n    @media(max-width: 1024px) {\n        width: 90%;\n    }\n}\n.contact-number-section {\n    margin-top: -10px;\n}\n.contact-number-label {\n    margin-left: 22px;\n}\n.dropdown {\n    margin-top: 5px;\n    width: 50.5%;\n    @media(max-width: 1024px) {\n        width: 90%;\n    }\n}\n.zip-code-section {\n    margin-top: -10px;\n}\n.contact-number-field {\n    margin-left: 7px;\n    width: 50%;\n    margin-top: 5px;\n    @media(max-width: 1024px) {\n        width: 90%;\n    }\n}\n.zip-code-label {\n    margin-left: 24px;\n}\n.time-section {\n    margin-top: -10px;\n}\n.time-period-label {\n    margin-left: 22px;\n}\n.time-period-field {\n    margin-left: 6px;\n    width: 50%;\n    margin-top: 5px;\n    @media(max-width: 1024px) {\n        width: 90%;\n    }\n}\n#time-period {\n    margin-top: 15px;\n    width: 100%;\n}\n.upload-section {\n  width: 100%;\n  margin-top: 15px;\n}\n.upload-label {\n    margin-left: 7px;\n    width: 90%;\n    margin-bottom: 2px;\n}\n.upload-heading-section {\n}\n#file-upload-section {\n    margin-left: 8px;\n}\n.file-details {\n    display: inline-block;\n}\n#selectFile {\n    width: 75%;\n    border-radius: 6px;\n    background-color: transparent;\n    color: #1483D9;\n    border: 1px solid #D0D1D2;\n}\n#file-upload-section {\n    width: 50%;\n}\n.notifications-label {\n    width: 100%;\n}\na:hover {\n    text-decoration: none;\n}\n.notification-labels {\n    margin-bottom: 20px;\n}\n.step-indicator {\n    width: 80%;\n    margin-left: 10%;\n}\n#notification-email-label {\n    margin-bottom: 15px;\n    margin-left: 5px;\n}\n#notification-text-label {\n    margin-left: 5px;\n}\n.acknowledgement-section {\n    width: 100%;\n    background-color: #f2f2f2;\n    display: flexbox;\n}\n.acknowledgement-heading {\n    margin-bottom: 5px;\n    font-size: 16px;\n    padding: 15px 15px 15px 15px;\n    color: #000000;\n    opacity: 1;\n    font-weight: 600;\n}\n.acknowledgement-subheading {\n    font-size: 16px;\n    padding: 0px 15px 15px 15px;\n    color: #000000;\n    opacity: 1;\n}\n\n.continue-section {\n    width: 100%;\n    height: 50px;\n    margin-bottom: 40px;\n}\n#cancel-option {\n    float: right;\n    margin-right: 20px;\n    font-size: 18px;\n    margin-top: 12px;\n}\n#continue-option {\n    float: right;\n}\n.time-slot-section {\n    margin-bottom: 30px;\n    margin-left: -10px;\n}\n.notifications-section {\n    margin-top: 15px;\n}\n.contact-name-error-field {\n    margin-left: 5px;\n    margin-top: 20px;\n}\n.ban-error-field, .contact-number-error-field, .time-slot-error-field {\n    margin-left: 5px;\n    margin-top: 20px;\n}\n:host ::ng-deep .text-danger {\n    margin-top: -10px;\n    margin-left: 15px;\n    margin-bottom: 20px;\n}\n// span.text-label-input {\n//     width: 50%;\n//   }\n  \n//   .tooltip-input {\n//     width: 50%;\n//   }\n  \n//   .display-inline-label {\n//     display: inline;\n//   }\n\n  .tooltipActive + .helper-text {\n    display: block;\n    width: 1200%;\n    bottom: 100%;\n    margin-left: -43px;\n    @include respond-to('small') {\n        width: 600%;\n    }\n  }\n  \n  .inline-labels {\n      display: inline-block;\n  }\n\n  .offers {\n      display: flex;\n      flex-direction: row;\n      .offer1 {\n          width: 375px;\n          height: 125px;\n          border: 1px solid black;\n          margin: 15px 25px 15px 25px;\n          border-radius: 40px;\n          padding: 10px;\n          .offer-rates {\n              margin-bottom: 0px;\n          }\n          .offer-headings {\n              margin-bottom: 0px;\n          }\n      }\n      .offer2 {\n        width: 375px;\n        height: 125px;\n        border: 1px solid black;\n        margin: 15px 25px 15px 25px;\n        border-radius: 40px;\n        padding: 10px;\n        .offer-rates {\n            margin-bottom: 0px;\n        }\n        .offer-headings {\n            margin-bottom: 0px;\n        }\n    }\n  }\n\n  .offers-1 {\n    display: flex;\n    flex-direction: row;\n    .offer1 {\n        width: 375px;\n        height: 125px;\n        border: 1px solid black;\n        margin: 15px 25px 25px 25px;\n        border-radius: 40px;\n        padding: 10px;\n        .offer-rates {\n            margin-bottom: 0px;\n        }\n        .offer-headings {\n            margin-bottom: 0px;\n        }\n    }\n    .offer2 {\n      width: 375px;\n      height: 125px;\n      border: 1px solid black;\n      margin: 15px 25px 25px 25px;\n      border-radius: 40px;\n      padding: 10px;\n      .offer-rates {\n        margin-bottom: 0px;\n    }\n    .offer-headings {\n        margin-bottom: 0px;\n    }\n  }\n}\n\n.firstnetErrorMessageLink {\n    color: #0000EE;\n    text-decoration: none;\n    outline: none;\n}\n\n.flex-section {\n    display: flex;\n}\n\n:host ::ng-deep .tooltip-input {\n    margin-top: 0%;\n    padding-left: 5%;\n}\n\n:host ::ng-deep i.tooltip-icon {\n    top: 16px;\n}\n\n:host ::ng-deep .helper-text {\n    margin-bottom: -9px;\n}\n\n.offer1-tooltip {\n    top: 2px !important;\n}\n\n.offer1-helper-text {\n    margin-bottom: 4px !important;\n}\n\n@include respond-to(small) {\n.tooltip-position {\n    padding-left: 20px;\n}\n}\n\n.sub-heading1 {\n    font-size: 25px;\n    margin-left: 0px !important;\n}\n\n@include respond-to(small) {\n    .sub-heading1 {\n    margin-left: 45px !important;\n    }\n    .secondHeading {\n        margin-top: -40px;\n    }\n    .radio-btn {\n        margin-top: 20px;\n    }\n}\n\n.radio-btn {\n    width: 20px;\n    margin-bottom:7px;\n    margin-left: 10px;\n    cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
